"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSpectrumFromRanges = void 0;
const nmr_processing_1 = require("nmr-processing");
const initiateDatum1D_1 = require("../initiateDatum1D");
function generateSpectrumFromRanges(ranges, info, usedColors) {
    const { nucleus, solvent, name = null, frequency = 400 } = info;
    try {
        const { x, y } = (0, nmr_processing_1.rangesToXY)(ranges, {
            nucleus,
            frequency,
            nbPoints: 2 ** 17,
        });
        const datum = (0, initiateDatum1D_1.initiateDatum1D)({
            data: { x, im: null, re: y },
            info: {
                nucleus,
                originFrequency: frequency,
                baseFrequency: frequency,
                pulseSequence: '',
                solvent,
                isFt: true,
                name,
            },
            ranges: { values: ranges, options: { sum: 100 } },
        }, { usedColors });
        return datum;
    }
    catch (error) {
        reportError(error);
    }
}
exports.generateSpectrumFromRanges = generateSpectrumFromRanges;
